// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"BrowserCheck_wrapper__5pchj","paragraph":"BrowserCheck_paragraph__9g8lN","link":"BrowserCheck_link__MQwCo","button":"BrowserCheck_button__wdA3H"};